module.exports = __webpack_public_path__ + "img/kit_dentflex_rosa.3c76d2ed.png";